module.exports = "<div class=\"modal-header\">\n    <h2>Evaluation</h2>\n</div>\n<div class=\"modal-body\"\n    id=\"marketplace-modal-body\">\n    <event-evaluation event-id=\"event_id\" profile-uid=\"profile_uid\">\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default pull-left\"\n        ng-click=\"close()\">Close</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/eventEvaluation/template.html
// module id = 1821
// module chunks = 0